/**
 * Created by User on 18/02/2016.
 */
import { AddonError } from 'mggp-player';
import Observer from './Observer';
import AdConsts from '../AdConsts';

export default Loader;

function Loader() {
  var self = this;
  var loader;

  this.destroy = function() {
    self.abort();
    loader = null;
  };

  this.abort = function() {
    if (loader && loader.readyState !== 4) {
      self.stats.aborted = true;
      loader.abort();
    }
    if (self.timeoutHandle) {
      window.clearTimeout(self.timeoutHandle);
    }
  };

  this.load = function(url, responseType, onSuccess, onError, onTimeout, timeout, useCredentials) {
    if (AdConsts.DEVICE_TYPE !== 'tv') {
      if (AdConsts.PROTOCOL === 'https:') {
        url = url.replace(/^https?:/, '');
      }
    }
    self.url = url;
    self.responseType = responseType || Loader.RESPONSE_TYPE_TEXT;
    self.onSuccess = onSuccess;
    self.onTimeout = onTimeout || null;
    self.onError = onError;
    self.timeout = timeout;
    self.useCredentials = useCredentials || false;
    self.maxRetry = 0;
    self._response = null;
    if (timeout) {
      self.timeoutHandle = window.setTimeout(_loadTimeout, timeout);
    }
    self.stats = { trequest: new Date(), retry: 0 };
    _loadInternal();
  };

  Object.defineProperty(this, 'response', {
    enumerable: true,
    get: function() {
      return self._response;
    }
  });

  var _loadInternal = function() {
    var xhr = loader = new XMLHttpRequest();
    xhr.onload = _loadSuccess;
    xhr.onerror = _loadError;
    xhr.onprogress = _loadProgress;
    xhr.open('GET', self.url, true);
    try {
      xhr.responseType = self.responseType;
    } catch (error) {}
    try {
      if (self.useCredentials) {
        xhr.withCredentials = true;
      }
    } catch (error) {}
    self.stats.tfirst = null;
    self.stats.loaded = 0;
    try {
      xhr.send();
    } catch (error) {
      if (self.onError) {
        self.onError(error);
      }
    }
  };

  var _loadSuccess = function(event) {
    if (self.timeoutHandle) {
      window.clearTimeout(self.timeoutHandle);
    }
    if (event.target.status == 200) {
      self.stats.tload = new Date();
      self._response = event.currentTarget.response;
      if (self.onSuccess) {
        self.onSuccess(event, self.stats);
      }
    } else {
      _loadError(event);
    }
  };

  var _loadError = function(event) {
    if (self.maxRetry === -1 || self.stats.retry < self.maxRetry) {
      self.destroy();
      if (self.timeoutHandle) {
        window.clearTimeout(self.timeoutHandle);
      }
      window.setTimeout(_loadInternal, self.retryDelay);
      // exponential backoff
      self.retryDelay = Math.min(2 * self.retryDelay, 64000);
      self.stats.retry++;
    } else {
      if (self.timeoutHandle) {
        window.clearTimeout(self.timeoutHandle);
      }
      if (self.onError) {
        self.onError(event, self.stats);
      }

      var errorType = AddonError.errorTypes.NETWORK_ERROR;
      var errorCode = AddonError.errorCodes[errorType].FILE_LOADING_ERROR;
      var errorMessage = AddonError.errorMessages[errorCode] + self.url;

      new AddonError(Observer.getObserverInstance(), errorType, errorCode, errorMessage);
    }
  };

  var _loadTimeout = function(event) {
    self.timeoutHandle = null;
    self.abort();
    if (self.onTimeout) {
      self.onTimeout(event, self.stats);
    }
  };

  var _loadProgress = function(event) {
    var stats = self.stats;
    if (stats.tfirst === null) {
      stats.tfirst = new Date();
    }
    stats.loaded = event.loaded;
    if (self.onProgress) {
      self.onProgress(event, stats);
    }
  };

}
Loader.prototype.constructor = Loader;

Loader.RESPONSE_TYPE_JSON = 'json';
Loader.RESPONSE_TYPE_TEXT = 'text';
Loader.RESPONSE_TYPE_DOCUMENT = 'document';
Loader.RESPONSE_TYPE_BLOB = 'blob';
Loader.RESPONSE_TYPE_ARRAYBUFFER = 'arraybuffer';
